import React, { useState } from "react";
import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { Mic, MicOff } from "@mui/icons-material";

// importing emailjs
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [isListening, setIsListening] = useState(false);
  const [inputText, setInputText] = useState("");

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    const sendEmail = async () => {
      try {
        await emailjs.sendForm(
          process.env.REACT_APP_SERVICE_ID,
          process.env.REACT_APP_TEMPLATE_ID,
          form.current,
          process.env.REACT_APP_PUBLIC_ID,
        );
        alert("Message sent successfully!");
        setInputText("");
      } catch (error) {
        alert("Some error occured!");
      }
      setInputText("");
    };
    sendEmail();
  };

  let recognition;
  const startRecognition = () => {
    setIsListening(true);
    setInputText("");

    recognition = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();

    recognition.lang = "en-US";
    recognition.interimResults = false; // get final result only

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setInputText(transcript);
    };

    recognition.onerror = function (event) {
      alert("Speech recognition error", event.error);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  const stopRecognition = () => {
    if (recognition) {
      recognition.stop();
      setIsListening(false);
    }
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <div className="contact__option">
            <MdOutlineEmail className="contact__option-image" />
            <h4>Email</h4>
            <a
              href="mailto:saransh7919@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </div>
          <div className="contact__option">
            <RiMessengerLine className="contact__option-image" />
            <h4>Messenger</h4>
            <a
              href="https://m.me/saransh.gangwar.35"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </div>
        </div>

        <form ref={form} onSubmit={sendEmail} >
{/*           <input type="hidden" name="access_key" value="37d9ebfe-ecfb-4d25-bc74-89aa661d879e" /> */}
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <div className="message-textarea-label">
            <p>Your Message</p>
            {!isListening ? (
              <div className="btn btn-primary mic" onClick={startRecognition}>
                <Mic />
              </div>
            ) : (
              <div className="btn btn-primary micoff" onClick={stopRecognition}>
                <MicOff />
              </div>
            )}
          </div>
          <textarea
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            name="message"
            rows="7"
            required
          />

          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
